import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
// import PropTypes from 'prop-types';

import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useFetch } from 'use-http';
import {
  BasicDialog,
  DrawerSendArchiveInspection,
  HeaderPage,
  TabCreateInspection,
  TourWrapper,
} from 'components';
import {
  avatar,
  getNewInspectionTabs,
} from 'components/TabCreateInspection/costants';

import { apiCollaborators, apiInspections } from 'constants/api';
import {
  InspectionRouteActions,
  InspectionStatus,
} from 'constants/inspections';
import { STRUCTURES_PATHS } from 'constants/paths';
import {
  PermissionType,
  PermissionTypeSelectOptions,
} from 'constants/permissions';
import { tour_06, tour_18 } from 'constants/tour';
import { UserType } from 'constants/users';
import { useInspectionPath } from 'hooks';
import { FormProvider } from 'providers';
import { useAuthSelector, useGlobalSelector, useGlobalStore } from 'stores';
import { BtnBottomContainer } from './CreateInspection.style';
import {
  l3Steps,
  steps,
  viewInspectionSteps,
} from './CreateInspection.tourSteps';
import CreateInspectionButtons from './CreateInspectionButtons';
import useInspectionL3 from './L3/useInspectionL3';
import useInspection from './useInspection';

const InspectionShareOptions = PermissionTypeSelectOptions.filter(
  el => el.value !== PermissionType.CanView
);
const CreateInspection = ({ action }) => {
  const { showLoader, hideLoader } = useGlobalSelector();
  const { user } = useAuthSelector();
  const { post } = useFetch();
  const { enqueueSnackbar } = useSnackbar();

  const { inspectionId, structureId } = useParams();
  const navigate = useNavigate();
  const { isViewingInspection } = useInspectionPath();

  //State
  const [showBtn, setShowBtn] = useState(false);
  const { state, pathname } = useLocation();
  const [openSendArchive, setOpenSendArchive] = useState(false);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [openWarningDialog, setOpenWarningDialog] = useState(false);

  const [debuggingSearch, setDebuggingSearch] = useState(
    'mensoleTamponiCampateImpalcatoTable'
  );

  // Inspection detail Hook with all logic
  const {
    titlePage,
    structure,
    infoData,
    methods,
    handleSubmit,
    onSubmit,
    collaborators,
    shareInspection,
    canShare,
    isStructureOwner,
    isInspectionOwner,
    formState,
    inspectionStatus,
    setWebCompletionPercentage,
    setAppCompletionPercentage,
    accessExpirationDate,
    isL3Activity,
  } = useInspection({
    inspectionId,
    structureId,
    openSendArchive,
  });

  // Attività L3: form indipendente dal form condiviso L0/L1 sopra, "alzato"
  // qui (invece di essere istanziato dentro L3Idraulica.jsx) per poter
  // mostrare Salva/Annulla nell'header condiviso — vedi
  // apps/web-bo/plans/features/l3-idraulica-tab.md.
  const l3 = useInspectionL3({ inspectionId });

  const newInspectionTabs = getNewInspectionTabs({
    l3,
    isL3Activity,
    inspectionStatus,
  });

  // Issue #1021, punto 25 — atterraggio sulla tab L3 se l'attività aperta è
  // di tipo L3, su L0 altrimenti (comportamento invariato) — solo quando
  // non è stato esplicitamente richiesto un altro tab (es. un link
  // "Approfondisci" da un riepilogo, che valorizza già
  // state.inspectionLevelTab). `??` non `||`: un eventuale
  // state.inspectionLevelTab=0 (Overview, esplicitamente richiesto) è
  // falsy e verrebbe scambiato per "non richiesto", sovrascritto dal
  // default L0/L3.
  // Riapertura 2026-09-24 — valore derivato ad ogni render, non più uno
  // state con un `useEffect` che lo sincronizzava un giro di render dopo
  // (isL3Activity `undefined` al primo render, poi risolto in modo
  // asincrono da useInspection.js): quel ritardo, per quanto di un solo
  // giro, produceva comunque un frame disegnato con la tab L0 selezionata
  // prima della correzione — "flash" segnalato dal cliente. Come valore
  // derivato puro, `initialTab` è sempre coerente con `isL3Activity`
  // nello stesso identico render in cui questo risolve, nessun ritardo
  // strutturalmente possibile. TabCreateInspection.jsx applica lo stesso
  // principio (derivazione sincrona, non più un effetto) per il proprio
  // `value` interno.
  const initialTab = state?.inspectionLevelTab ?? (isL3Activity ? 4 : 1);

  // Sidebar.jsx non ha visibilità sull'attività aperta qui: le serve per
  // nascondere il pulsante "Guida Interattiva" in view su un'attività L3,
  // su qualunque tab (issue #1021, 2026-09-28). Sincronizzato via effetto
  // (non un valore derivato: arriva da fetch, non da props/state locali) —
  // resta `undefined` finché isL3Activity non risolve, letto come "nascondi"
  // lato Sidebar.
  useEffect(() => {
    useGlobalStore.setState({ activeInspectionIsL3Activity: isL3Activity });
  }, [isL3Activity]);

  //Function
  const btnOnScroll = () => {
    document.body.scrollTop > 100 || document.documentElement.scrollTop > 100
      ? setShowBtn(true)
      : setShowBtn(false);
  };
  window.onscroll = () => btnOnScroll();

  const handleArchiveInspection = async () => {
    try {
      showLoader();
      await post(
        `${apiInspections.ROOT}/${inspectionId}${apiInspections.ARCHIVE}`
      );
      navigate(
        STRUCTURES_PATHS.INSPECTIONS_ARCHIVE.replace(
          ':structureId',
          structure?.id
        )
      );
    } catch (err) {
      return enqueueSnackbar(
        `Si è verificato un errore nell'archiviazione dell'ispezione`,
        {
          variant: 'error',
        }
      );
    } finally {
      hideLoader();
    }
  };

  const DebuggingOptions = [
    'spalleTable',
    'pileTable',
    'spallePileCollegamentiTable',
    'mensoleTamponiCampateImpalcatoTable',
    'sovrastrutturaImpalcatoTable',
    'paliTable',
    'sottoserviziTable',
    'convogliamentoAcqueTable',
    'vulnerabilitaStrutturaleBassa',
  ];

  const handleSendArchive = () => {
    if (
      Object.keys(formState?.touchedFields || {}).length > 0 &&
      !formState?.isSubmitSuccessful &&
      pathname.split('/').pop() !== InspectionRouteActions.VIEW
    ) {
      /* console.log('MODIFICHE NON SALVATE', formState?.touchedFields); */
      return setOpenWarningDialog(true);
    }
    setOpenSendArchive(true);
  };

  return (
    <>
      {(process.env.REACT_APP_ENVIRONMENT == 'develop' ||
        process.env.REACT_APP_ENVIRONMENT == 'test') && (
        <Grid container spacing={2} my={3}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">nome rhf</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="nome RHF"
                onChange={event => setDebuggingSearch(event.target.value)}
              >
                {DebuggingOptions.map(el => (
                  <MenuItem key={el} value={el}>
                    {el}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <Button
              color="secondary"
              fullWidth
              variant="contained"
              onClick={() => {
                console.log(methods.getValues());
              }}
            >
              vedi tutte le opzioni
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              color="info"
              fullWidth
              variant="contained"
              onClick={() => {
                console.log(methods.getValues(debuggingSearch));
              }}
            >
              analizza elemento RHF
            </Button>
          </Grid>
        </Grid>
      )}
      <FormProvider
        methods={methods}
        onSubmit={handleSubmit(onSubmit, console.log)}
      >
        <HeaderPage
          sharedWith={collaborators}
          shareOptions={InspectionShareOptions}
          back={STRUCTURES_PATHS.INSPECTIONS_ARCHIVE.replace(
            ':structureId',
            structure?.id
          )}
          isOwner={isStructureOwner}
          handleShare={shareInspection}
          canShare={canShare}
          shareRoute={apiCollaborators.INSPECTIONS_COLLBAORATORS}
          entityId={inspectionId}
          accessExpiration={accessExpirationDate}
          buttons={
            <>
              <div className={`${tour_06.step_05} ${tour_18.step_04}`}>
                {structure && (
                  <CreateInspectionButtons
                    setWebCompletionPercentage={setWebCompletionPercentage}
                    setAppCompletionPercentage={setAppCompletionPercentage}
                    action={action}
                    structure={structure}
                    inspectionId={inspectionId}
                    l3={l3}
                  />
                )}
                {user?.type === UserType.Professionista &&
                  inspectionStatus !== InspectionStatus.Archived &&
                  inspectionStatus !== InspectionStatus.Delivered &&
                  isInspectionOwner && (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={handleSendArchive}
                    >
                      Consegna e Archivia
                    </Button>
                  )}
                {user?.type === UserType.Ente &&
                  inspectionStatus !== InspectionStatus.Archived &&
                  inspectionStatus !== InspectionStatus.Delivered && (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => setOpenArchiveDialog(true)}
                    >
                      Termina e Archivia
                    </Button>
                  )}
              </div>
            </>
          }
          title={titlePage}
          avatar={avatar}
          infoData={infoData}
        />
        <div style={{ marginTop: 30 }}>
          <TabCreateInspection
            typevariant="secondary"
            variant="fullWidth"
            tabs={newInspectionTabs}
            initialTab={initialTab}
            firstLevel={true}
            // Issue #1021, riapertura 2026-09-24 — nessuna tab deve
            // apparire selezionata (blu) finché isL3Activity non è
            // risolto: vedi commento su tabsLoading in
            // TabCreateInspection.jsx.
            tabsLoading={isL3Activity === undefined}
            extraForms={[{ formState: l3.formState, reset: l3.methods.reset }]}
          />
        </div>
        {showBtn && structure && (
          <BtnBottomContainer>
            <CreateInspectionButtons
              setWebCompletionPercentage={setWebCompletionPercentage}
              setAppCompletionPercentage={setAppCompletionPercentage}
              action={action}
              structure={structure}
              inspectionId={inspectionId}
              l3={l3}
            />
          </BtnBottomContainer>
        )}
      </FormProvider>
      {/* Guida al primo accesso — in modifica, tour dedicato quando
      l'attività aperta è L3 (blocco ID18 del file Excel, tour_18) invece di
      quello L0,1,2 (tour_06, invariato). In "view" (attività non
      modificabile: archiviata/consegnata/consegna in corso), stesso gate:
      `viewInspectionSteps` punta a `tour_06a.step_01`, presente solo nei
      wrapper delle tab L0/L1 (TabCreateInspection/costants.js) — su
      un'attività L3 quella classe non è mai montata (tab L2/L3 diverse),
      quindi nessuna guida, non un tour L3 dedicato (issue #1021, punto
      2026-09-28: la cliente non vuole alcuna guida in view su L3, il
      messaggio "quattro macro categorie" non le si applica). */}
      {!isViewingInspection && !isL3Activity && <TourWrapper steps={steps} />}
      {!isViewingInspection && isL3Activity && (
        <TourWrapper steps={l3Steps} />
      )}
      {isViewingInspection && !isL3Activity && (
        <TourWrapper steps={viewInspectionSteps} />
      )}
      <DrawerSendArchiveInspection
        open={openSendArchive}
        setOpen={setOpenSendArchive}
        inspectionId={inspectionId}
        structureId={structure?.id}
        onSubmitCallback={() => {
          navigate(
            STRUCTURES_PATHS.INSPECTIONS_ARCHIVE.replace(
              ':structureId',
              structure?.id
            )
          );
        }}
      />
      <BasicDialog
        title="Attenzione"
        open={openWarningDialog}
        onClose={() => setOpenWarningDialog(false)}
        actions={
          <>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => setOpenWarningDialog(false)}
            >
              Annulla
            </Button>
          </>
        }
      >
        Ci sono delle modifiche non salvate nel pannello corrente. Assicurarsi
        di aver salvato l&rsquo;ispezione prima di consegnarla
      </BasicDialog>
      <BasicDialog
        title="Attenzione"
        open={openArchiveDialog}
        actions={
          <>
            <Button
              color="secondary"
              onClick={() => setOpenArchiveDialog(false)}
            >
              Annulla
            </Button>
            <Button variant="contained" onClick={handleArchiveInspection}>
              Termina e archivia
            </Button>
          </>
        }
        onClose={() => setOpenArchiveDialog(false)}
      >
        <Typography>
          Assicurati di aver concluso l&apos;attività.
          <br />
          Archiviando non sarà più possibile modificarla
        </Typography>
      </BasicDialog>
    </>
  );
};

CreateInspection.propTypes = {
  action: PropTypes.oneOf([
    InspectionRouteActions.CREATE,
    InspectionRouteActions.EDIT,
    InspectionRouteActions.VIEW,
  ]),
};

export default CreateInspection;
